import React from 'react'
import { Card, CardActionArea, CardContent, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Topic as ITopic } from '../../../../types/academy'
import { ArrowForward as ArrowForwardIcon } from '@material-ui/icons'
import RandomColor from 'randomcolor'
import Image from 'next/image'

interface styleProps {
  backgroundColor: string
}

const useStyles = makeStyles((theme) => ({
  root: {},
  viewMoreRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: theme.palette.primary.main,
  },
  image: {
    height: '8rem',
    width: '80%',
    alignSelf: 'center',
    position: 'relative',
    borderRadius: '4px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  viewMoreContent: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: '16px',
    fontWeight: 700,
    fontFamily: theme.typography.h1.fontFamily,
  },
  actionArea: {
    maxWidth: '320px',
    backgroundColor: (props: styleProps) => props.backgroundColor,
    padding: '1rem',
    height: '14rem',
    '&:hover $focusHighlight': {
      opacity: 0,
    },
  },
  focusHighlight: {},
  viewMoreIcon: {
    background: 'rgba(43, 24, 65, 0.06)',
    padding: '10px 20px',
    borderRadius: '100px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

interface Props {
  topic: ITopic
}

function TopicCard({ topic }: Props): JSX.Element {
  const { title, slug, image } = topic
  const color = RandomColor({ alpha: 0.2, format: 'rgba', luminosity: 'random', hue: 'random' })
  const classes = useStyles({ backgroundColor: color })

  return (
    <Card elevation={0} className={classes.root}>
      <CardActionArea
        classes={{ root: classes.actionArea, focusHighlight: classes.focusHighlight }}
        href={`/lesson?topic=${slug}`}
        disableRipple
      >
        <CardContent className={classes.content}>
          <Typography variant="body1" className={classes.title}>
            {title}
          </Typography>
          <div className={classes.image}>
            <Image layout="fill" objectFit="cover" src={image?.url} />
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export function ViewMoreTopicsCard(): JSX.Element {
  const classes = useStyles({ backgroundColor: 'rgba(0, 0, 0, 0.04)' })

  return (
    <Card elevation={0} className={`${classes.root} ${classes.viewMoreRoot}`}>
      <CardActionArea
        classes={{
          root: `${classes.actionArea}`,
          focusHighlight: classes.focusHighlight,
        }}
        href={`/topics`}
        disableRipple
      >
        <CardContent className={`${classes.content} ${classes.viewMoreContent}`}>
          <Typography variant="body1" className={classes.title}>
            See All Topics
          </Typography>
          <div className={classes.viewMoreIcon}>
            <ArrowForwardIcon />
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default TopicCard
